import React from 'react';
import Divider from '../../../ui_kit/utilities/divider';
import MentorCard from '../mentor_card/index';
import styles from '../../../questionnaire/questionnaire.module.css';

export default function MentorMatch({
  patientPartner,
  callback,
  stateOnlyLocation = false,
  whatsNextMessage = (p) => {
    return `Send your first message to ${p.name} and get answers to questions about the procedure, recovery, and their experience.`;
  },
}) {
  return (
    <div className={'container'}>
      <div className='row'>
        <h3 className={styles.question} style={{ fontWeight: '700' }}>
          You've been matched with {patientPartner.name}!
        </h3>
        <Divider color={'#173959'} />
        <h5 className={`${styles.light_blue_text} marg-top-15`}>meet your mentor</h5>
        <div className='marg-top-20'>
          {patientPartner && (
            <MentorCard mentor={patientPartner} callback={callback} stateOnlyLocation={stateOnlyLocation} />
          )}
        </div>
        <div className='container'>
          <div className='row'>
            <h5 className={`${styles.light_blue_text} marg-bottom-10`}>What's next?</h5>
          </div>
          <div className='row'>
            <p className={styles.para}>{whatsNextMessage(patientPartner)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
